import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./AddBreakdown.css";

const EditDriver = () => {
  const [formData, setFormData] = useState({
    reporting_driver_code: "",
    driver_name: "",
    is_active: "Y",
  });
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const fetchDriver = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/drivers/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setFormData(response.data);
      } catch (error) {
        console.error("Error fetching driver:", error);
      }
    };
    fetchDriver();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        `${process.env.REACT_APP_BASE_API_URL}/drivers/${id}`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      navigate("/driver-management");
    } catch (error) {
      console.error("Error updating driver:", error);
    }
  };

  return (
    <div className="container-add-breakdown">
      <button
        className="close-button"
        onClick={() => navigate("/driver-management")}
      >
        ×
      </button>
      <form onSubmit={handleSubmit} className="form-grid-breakdown">
        <div>
          <label className="form-label-breakdown">
            Driver Code <span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-input-breakdown"
            name="reporting_driver_code"
            value={formData.reporting_driver_code}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label className="form-label-breakdown">
            Driver Name <span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-input-breakdown"
            name="driver_name"
            value={formData.driver_name}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label className="form-label-breakdown">
            Status <span className="required">*</span>
          </label>
          <select
            className="form-input-breakdown form-select-breakdown"
            name="is_active"
            value={formData.is_active}
            onChange={handleChange}
            required
          >
            <option value="Y">Active</option>
            <option value="N">Inactive</option>
          </select>
        </div>

        <button type="submit" className="submit-button-breakdown1">
          Update
        </button>
      </form>
    </div>
  );
};

export default EditDriver;
